"use client"

import { Clock7 } from 'lucide-react';
interface CountdownDialProps {
  days: number
  hours: number
  minutes: number
  seconds: number
}

const baseStyles = 'text-sm bg-white/10 px-2 py-1 rounded font-semibold text-white '
const labelStyles = ' text-[9px] font-semibold text-white/80 uppercase tracking-wider mt-1'

export const CountdownDial: React.FC<CountdownDialProps> = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="flex items-center justify-center gap-2">
      {/* Days */}
      <div className="flex flex-col items-center">
        <div className={baseStyles}>{String(days).padStart(2, "0")}</div>
        <div className={labelStyles}>Days</div>
      </div>

      {/* <span className="text-3xl font-bold text-white/90">:</span> */}

      {/* Hours */}
      <div className="flex flex-col items-center">
        <div className={baseStyles}>{String(hours).padStart(2, "0")}</div>
        <div className={labelStyles}>Hours</div>
      </div>

      {/* <span className="text-2xl font-bold text-white/90">:</span> */}

      {/* Minutes */}
      <div className="flex flex-col items-center">
        <div className={baseStyles}>{String(minutes).padStart(2, "0")}</div>
        <div className={labelStyles}>Mins</div>
      </div>

      {/* <span className="text-2xl font-bold text-white/90">:</span> */}

      {/* Seconds */}
      <div className="flex flex-col items-center">
        <div className={baseStyles}>{String(seconds).padStart(2, "0")}</div>
        <div className={labelStyles}>Secs</div>
      </div>
    </div>
  )
}

